import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useHover } from '../../../hooks/useHover';
import styles from './IconButton.module.scss';

const IconButtonComponent = ({ icon, to = '#', className = '', onClick = null, disabled = false }) => {
  const [wrapperRef, isHover] = useHover<HTMLDivElement>();

  return (
    <>
      <div
         className={`${styles.iconButtonWrapper} ${className}`}
        ref={wrapperRef}
        style={{ pointerEvents: disabled ? 'none' : null }}
        onClick={(e) => {
          onClick && onClick(e);
        }}
      >
        <Link to={to}>
           <div className={`text-light ${styles.lightButton}`}>
            <FontAwesomeIcon icon={icon} size={'lg'} />
          </div>
        </Link>
      </div>
    </>
  );
};

export { IconButtonComponent as IconButton };
